// External Dependencies
import React from 'react';
import firebase from 'firebase';
import {
  IndexRedirect,
  IndexRoute,
  Route,
} from 'react-router';

// Internal Dependencies
import BadgeList from './badges/BadgeList';
import CoderDetailsPage from './ninjas/CoderDetailsPage';
import CodersPage from './ninjas/CodersPage';
import Dashboard from './dashboard';
import DashboardEmptyState from './dashboard/dashboard-empty-state';
import AppMainContainer from './app-main-container';
import HomePageContent from './home/HomePageContent';
import UpdateAttendance from './dashboard/update-attendance';
import UpdateNinjas from './dashboard/update-ninjas';
import {
  getDashboardUrl,
  getUpdateAttendanceUrl,
  getUpdateNinjasUrl,
} from './route-urls';

// Local Functions
const requireLogin = (nextState, replace, next) => {
  if (!firebase.auth().currentUser || !firebase.auth().currentUser.email.includes('@call-em-all.com')) {
    replace('/Home');
  }
  next();
};

// Route definitions
export const routes = (
  <Route component={AppMainContainer} path="/">
    <IndexRedirect to="/Home" />
    <Route component={HomePageContent} path="/Home" />
    <Route component={CodersPage} path="/CodersPage" />
    <Route component={BadgeList} path="/BadgeList" />
    <Route component={CoderDetailsPage} path="/coder-details/:key" />

    {/* Dashboard */}
    <Route component={Dashboard} path={getDashboardUrl()} onEnter={requireLogin}>
      <IndexRoute component={DashboardEmptyState} />
      <Route component={UpdateAttendance} path={getUpdateAttendanceUrl()} />
      <Route component={UpdateNinjas} path={getUpdateNinjasUrl()} />
    </Route>
  </Route>
);

export default routes;



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/